import React, { useState, useEffect } from 'react';
import axios from 'axios'
import {
    Image,
} from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap';

export default function FindClinicImage (props) {
    const clinic = props.clinic;
    const noImage = "https://upload.wikimedia.org/wikipedia/commons/thumb/archive/a/ac/20121003093557%21No_image_available.svg/120px-No_image_available.svg.png";
    const [logo, setLogo] = useState(clinic.logo_url || noImage);

    useEffect( () => {


    axios.post("https://uae-dentist-backend.herokuapp.com/account/get-logo", {clinic_id: clinic._id})
    .then(result => {
        if(result.data.length > 10){
            setLogo('data:image/jpeg;base64,'+ result.data);
        }
    })
    }, [clinic._id]);

    return (
        <LinkContainer style={{ cursor: "pointer" }} to={{
            pathname: `/clinic/${clinic.clinic_name.toLowerCase()}/`,
            state: { clinic },
        }}>
        <Image
        className="mr-3"
        roundedCircle
        width={props.width}
        height={props.height}
        src={logo}
        alt="Card image cap"
      />
    </LinkContainer>
    );
}